import React, {useEffect, useState} from "react";
import I18n from "i18n-js";
import {
  addHtmlElementClass,
  focusHtmlElement,
  isDefined,
  parseAmount,
  removeHtmlElementClass,
  setHtmlElementContent,
  handleRenderWalletBadge
} from "../../utils/utils";
import Modal from "react-bootstrap/Modal";
import SuccessFlashMessage from "./SuccessFlashMessage";

const PrepaidCardStateManagerButton = ({
  userId,
  buttonText,
  prepaidCards,
  setPrepaidCards,
  action
}) => {

  const [ showPopup, setShowPopup ] = useState(false)
  const emptyCardCharacters = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
  const [ focusedIndex, setFocusedIndex ] = useState(0)
  const [ cardCharacters, setCardCharacters ] = useState(emptyCardCharacters);
  const [ changedCode, setChangedCode ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState(null);
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false)
  const [ successMessage, setSuccessMessage ] = useState(null)


  useEffect(() => {
    focusHtmlElement(document, `char_${focusedIndex}`)
  }, [focusedIndex]);


  useEffect(() => {
    setChangedCode(true);
  }, [cardCharacters]);


  // Funzione che gestisce la chiusura della modale che permette all'utente di attivare / riscattare una carta prepagata
  const handleCloseModal = () => {
    setCardCharacters(emptyCardCharacters);
    setFocusedIndex(0);
    setErrorMessage(null);
    setShowPopup(false);
  }


  // Funzione che permette all'utente di specificare un nuovo carattere che compone il codice
  // della carta di credito prepagata che intende attivare / riscattare
  const updatePrepaidCardCode = (value, index) => {
    setErrorMessage(null);

    const newCardCharacters = [ ...cardCharacters ];
    for (let i = 0; i < cardCharacters.length; i++)
      if (i === index)
        newCardCharacters[i] = value;
    setCardCharacters(newCardCharacters);

    if (index <= 14 && isDefined(value))
      setFocusedIndex(index + 1)
  }


  // Funzione che gestisce l'attivazione / il riscatto della carta prepagata da parte dell'utente
  const onActivateCardHandler = () => {
    if (changedCode) {
      setChangedCode(false);
      const url = `/users/${userId}/prepaid_cards/change_state/${action}/${cardCharacters.join().replaceAll(',', '')}`;

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({})
      })
        .then((response) => {
          // console.log('response: ', response)
          if (response.ok)
            return response.json();
          else
            throw Error(I18n.t(`js.indexPrepaidCards.${action}_errors.${response.status}`));
        })
        .then((data) => {
          // console.log(data)
          if (setPrepaidCards)
            setPrepaidCards([data, ...prepaidCards.slice(0, 5)]);
          else if (action === 'redeem') {
            removeHtmlElementClass(document, 'wallet_section_link', 'd-none');
            addHtmlElementClass(document, 'wallet_section_link', 'd-flex');
            setHtmlElementContent(document, 'user_wallet_amount', parseInt(parseAmount(data.amount, 0)));
            setHtmlElementContent(document, 'wallet_amount', parseInt(parseAmount(data.amount, 0)));
            handleRenderWalletBadge(data.amount);
          }
          handleCloseModal();
          setSuccessMessage(I18n.t(`js.indexPrepaidCards.${action}Completed`))
          setShowSuccessFlashMessage(true);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setErrorMessage(error.message);
        });
    }
  }

  return <React.Fragment>
    <button
      className="btn bg-aig-gradient br-50px border-none color-white mt-0 mb-1 mx-2 py-2 px-3 font-weight-bold"
      onClick={() => setShowPopup(true)}
    >
      {buttonText}
    </button>


    <Modal show={showPopup} onHide={handleCloseModal} animation={false} size="lg" centered>
      <Modal.Header>
        <Modal.Title>{I18n.t(`js.indexPrepaidCards.title${action}Popup`)}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row w-100 mx-2 px-0 d-flex justify-content-center flex-wrap my-2">
          {
            cardCharacters.map((c, i) => {
              return (
                <input
                  type="text"
                  className={`form-control ${[3, 7, 11].includes(i) ? 'mr-2' : 'mr-1' } ${[4, 8, 12].includes(i) ? 'ml-2' : 'ml-0' } prepaid-card-character-input my-2 px-2`}
                  key={`char_${i}`}
                  name={`char_${i}`}
                  id={`char_${i}`}
                  value={c ? c : ''}
                  autoFocus={i === 0}
                  onChange={(e) => updatePrepaidCardCode(e.target.value ? e.target.value.toUpperCase()[0] : '', i)}
                />
              )
            })
          }
        </div>

        {
          errorMessage &&
            <div className="row w-100 mx-2 px-0 d-flex justify-content-center mb-4 text-aig-gradient">
              {errorMessage}
            </div>
        }
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized text-weight-500"
          onClick={handleCloseModal}>
          {I18n.t("js.indexPrepaidCards.cancel").toUpperCase()}
        </button>

        <button
          type="button"
          className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px text-weight-500"
          onClick={onActivateCardHandler}
          disabled={cardCharacters.filter(c => !isDefined(c)).length > 0}
        >
          {I18n.t("js.indexPrepaidCards.activate").toUpperCase()}
        </button>

      </Modal.Footer>
    </Modal>


    <SuccessFlashMessage
      showSuccessFlashMessage={showSuccessFlashMessage}
      setShowSuccessFlashMessage={setShowSuccessFlashMessage}
      successMessage={successMessage}
    />
  </React.Fragment>
};

export default PrepaidCardStateManagerButton;